
import EventEmitter from 'eventemitter3';
import { PlayerVersion } from '../constant';

const LOG_LEVEL = {
    debug:1,
    info:2,
    warn:3,
    error:4

}

class Logger extends EventEmitter {

    logEnable = false; 
    logLevel = LOG_LEVEL.info

    logsCache = []
    logsCacheMaxNum = 1000

    player

    constructor(player) {

        super()

        this.player = player
    }

    setLogEnable(logEnable) {

        this.logEnable = logEnable;
    }

    setLogLevel(logLevel) {

        if (LOG_LEVEL[logLevel]) {

            this.logLevel = LOG_LEVEL[logLevel]
        }
    }

    getCurrentTime() {
       
        let now = new Date();
        let dateString = now.toISOString().split('T')[0];  // ��ʱ��ת��Ϊ'YYYY-MM-DD'��ʽ
        let timeString = now.toTimeString().split(' ')[0];  // ��ʱ��ת��Ϊ'hh:mm:ss'��ʽ
        return `${dateString} ${timeString}`;  // �����ں�ʱ��ƴ������
    }

    debug(module, ...args)  {
        
        if (this.logEnable &&  LOG_LEVEL.debug >= this.logLevel) {

            let log = `[${this.getCurrentTime()}][HMPlayer-${this.player.options.playerId}][DEBUG][${module}] ${args.join(",")} \n` 
            console.debug(log);
            this.emit('logdata', log)
        }
    }

    info(module, ...args)  {
        if (this.logEnable &&  LOG_LEVEL.info >= this.logLevel) {

            let log = `[${this.getCurrentTime()}][HMPlayer-${this.player.options.playerId}][INFO][${module}] ${args.join(",")} \n` 
            console.info(log);
            this.emit('logdata', log)
        }
    }

    warn (module, ...args) {
        if (this.logEnable && LOG_LEVEL.warn >= this.logLevel) {

            let log = `[${this.getCurrentTime()}][HMPlayer-${this.player.options.playerId}][WARN][${module}] ${args.join(",")} \n` 
            console.warn(log);
            this.emit('logdata', log)
        }
    }

    error(module, ...args) {
        if (this.logEnable && LOG_LEVEL.error >= this.logLevel) {

            let log = `[${this.getCurrentTime()}][HMPlayer-${this.player.options.playerId}][ERROR][${module}] ${args.join(",")} \n` 
            console.error(log);
            this.emit('logdata', log)
        }
    }

    appendLog(log) {

        this.logsCache.push(log)

        if (this.logsCache.length > this.logsCacheMaxNum) {

            this.logsCache.shift()
        }
    }

    logsHeader() {

        let gpu = 'unknown'
        var canvas = document.createElement("canvas");
        var gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
        if (gl) {
          var info = gl.getExtension("WEBGL_debug_renderer_info");
          if (info) {
            gpu = gl.getParameter(info.UNMASKED_RENDERER_WEBGL);
          } 
        }


let header = `--------------- Header(S) ---------------
version: ${PlayerVersion}
creationTime: ${new Date().toString()}
userAgent: ${navigator.userAgent}
cookieEnabled: ${navigator.cookieEnabled}
hardwareConcurrency: ${navigator.hardwareConcurrency}
maxTouchPoints: ${navigator.maxTouchPoints}
deviceMemory: ${navigator.deviceMemory}GB
devicePixelRatio: ${window.devicePixelRatio}
viewport: width:${this.player.options.width},height:${this.player.options.height}
screen: width:${window.screen.width},height:${window.screen.height},colorDepth:${window.screen.colorDepth}
gpu: ${gpu}
--------------- Header(E) ---------------

`
        return header
    }

    getLogsCache() {


        return [this.logsHeader(), ...this.logsCache]
    }

    destroy() {

        this.off()
    }

}

let logger = undefined

function createLogger(player, logEnable, logLevel) {

    if (!logger) {

        logger = new Logger(player)
    }

    logger.setLogEnable(logEnable)
    logger.setLogLevel(logLevel)

}

function destroyLogger() {

    logger?.destroy()

}

export {logger, createLogger, destroyLogger};
